import { render, staticRenderFns } from "./BottomMenuBar.vue?vue&type=template&id=798d2f22&"
import script from "./BottomMenuBar.vue?vue&type=script&lang=js&"
export * from "./BottomMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports